<template>

<div>
	<div class="section center" style="margin: 0 0 1em 2em; padding: 0 0 0.5em 0; border-bottom: 1px solid #ccc;">
		<div v-if="editing"><i class="fas fa-edit"></i> <b>MOVING RECORD {{ entry.sequence_code }} &mdash; MAKE CHANGES AND THEN CLICK "SAVE MOVED RECORD" BELOW.</b></div>
		<div v-else-if="entryCopy.moved_to_ffl_log_book_entry_id"><i class="fas fa-lock"></i> <b>THIS RECORD HAS BEEN MOVED</b></div>
		<div v-else-if="entryCopy.is_disposed"><i class="fas fa-lock"></i> <b>THIS FIREARM IS DISPOSED</b></div>
		<div v-else-if="entryCopy.disposal_full_name"><b>THIS FIREARM IS ON HAND, SALE INFO IS SHOWN FOR CONVENIENCE</b></div>
		<div v-else><b>THIS FIREARM IS ON HAND</b></div>
	</div>

	<div class="detail two-columns" id="record_top">

		<div class="section">
			<h2>Receipt Info</h2>
			<div class="two-columns">
				<label v-if="editing">Logbook</label>
				<label v-else>Sequence</label>
				<label>Date</label>
				<select v-if="editing" v-model="entryCopy.ffl_log_book_id">
					<option value="">Select...</option>
					<option v-for="logbook in logbooks" :value="logbook.ffl_log_book_id">{{ logbook.ffl_log_book_code }} - {{ logbook.description }}</option>
				</select>
				<div v-else class="detail-data">{{ entryCopy.sequence_code }}</div>
				<div v-if="editing"><input type="date" v-model="entryCopy.receipt_date" :max="$today().clone().format('YYYY-MM-DD')"></div>
				<div v-else class="detail-data">{{ $moment(entryCopy.receipt_date, 'YYYY-MM-DD').format('MM/DD/YYYY') }}</div>
			</div>
			<label>Received From</label>
			<div v-if="editing">
				<input type="text" v-model="entryCopy.originator_full_name">
				<input type="text" v-model="entryCopy.originator_address_1">
				<div class="three-columns">
					<input type="text" v-model="entryCopy.originator_city">
					<state-select type="text" :selectedState="entryCopy.originator_state" placeHolder="Select..." @updateSelected="updateSelectedStateOriginator"></state-select>
					<input type="text" v-model="entryCopy.originator_zip_code">
				</div>
				<input type="text" v-model="entryCopy.originator_ffl_number" placeholder="FFL Number / DL Number">
			</div>
			<div v-else class="detail-data">
				<div>{{ entryCopy.originator_full_name }}</div>
				<div>{{ entryCopy.originator_address_1 }}</div>
				<div v-if="entryCopy.originator_address_2">{{ entryCopy.originator_address_2 }}</div>
				<div>{{ entryCopy.originator_city }}, {{ entryCopy.originator_state }} {{ entryCopy.originator_zip_code }}</div>
				<div v-if="entryCopy.originator_ffl_number">{{ entryCopy.originator_ffl_number }}</div>
			</div>
		</div>

		<div class="section">
			<h2 v-if="!entryCopy.is_disposed && entryCopy.disposal_full_name">Sale Info <span style="float: right;">Record is Not Disposed</span></h2>
			<h2 v-else>Disposition Info</h2>
			<div v-if="!entryCopy.disposal_full_name && !editing" class="empty-list">
				No Dispositon Info
			</div>
			<template v-else>
				<div class="two-columns">
					<label>Date</label>
					<label></label>
					<div v-if="editing"><input type="date" v-model="entryCopy.disposal_date" :max="$today().clone().format('YYYY-MM-DD')"></div>
					<div v-else class="detail-data">{{ $moment(entryCopy.disposal_date, 'YYYY-MM-DD').format('MM/DD/YYYY') }}</div>
					<div v-if="!entryCopy.is_disposed" style="width: 15em; text-align: right;"><div class="button action" @click="showTip('confirm_clear_disposition_info')">Clear Sale Info</div></div>
					<div v-else></div>
				</div>
				<label>{{ !entryCopy.is_disposed ? 'Sold' : 'Disposed' }} To</label>
				<div v-if="editing">
					<input type="text" v-model="entryCopy.disposal_full_name">
					<input type="text" v-model="entryCopy.disposal_address_1">
					<div class="three-columns">
						<input type="text" v-model="entryCopy.disposal_city">
						<state-select type="text" :selectedState="entryCopy.disposal_state" placeHolder="Select..." @updateSelected="updateSelectedStateDisposal"></state-select>
						<input type="text" v-model="entryCopy.disposal_zip_code">
					</div>
					<input type="text" v-model="entryCopy.disposal_ffl_number" placeholder="FFL Number / DL Number">
				</div>
				<div v-else class="detail-data">
					<div>{{ entryCopy.disposal_full_name }}</div>
					<div>{{ entryCopy.disposal_address_1 }}</div>
					<div v-if="entryCopy.disposal_address_2">{{ entryCopy.disposal_address_2 }}</div>
					<div>{{ entryCopy.disposal_city }}, {{ entryCopy.disposal_state }} {{ entryCopy.disposal_zip_code }}</div>
					<div v-if="entryCopy.disposal_ffl_number">{{ entryCopy.disposal_ffl_number }}</div>
				</div>
			</template>
		</div>

		<div class="section">
			<h2>ATF Details</h2>
			<div class="two-columns">
				<div>
					<label v-if="editing">Manufacturer</label>
					<div v-if="editing"><input type="text" v-model="entryCopy.manufacturer"></div>

					<label v-if="editing">Importer</label>
					<div v-if="editing"><input type="text" v-model="entryCopy.importer"></div>

					<label v-if="!editing">Manufacturer / Importer</label>
					<div v-if="!editing" class="detail-data">{{ entryCopy.manufacturer + (entryCopy.importer ? ' / ' + entryCopy.importer : '') }}</div>

					<div v-if="fflNumberInfo.manufacturer_importer">
						<label>Country of Manufacture</label>
						<div v-if="editing"><input type="text" v-model="entryCopy.country_of_manufacture"></div>
						<div v-else class="detail-data">{{ entryCopy.country_of_manufacture || "&nbsp;" }}</div>
					</div>

					<label>Model</label>
					<div v-if="editing"><input type="text" v-model="entryCopy.model"></div>
					<div v-else class="detail-data">{{ entryCopy.model }}</div>

				</div>
				<div>
					<label>Type</label>
					<div v-if="editing"><select name="gun_type" v-model="entryCopy.gun_type">
						<option value="">Select...</option>
						<option v-for="gun_type in gun_types" :value="gun_type">{{ gun_type }}</option>
					</select></div>
					<div v-else class="detail-data">{{ entryCopy.gun_type }}</div>

					<label>Caliber</label>
					<div v-if="editing"><input type="text" v-model="entryCopy.caliber"></div>
					<div v-else class="detail-data">{{ entryCopy.caliber }}</div>

				</div>
			</div>
		</div>

		<div class="section">
			<div>
				<h2>Dispose{{ entryCopy.is_disposed ? 'd' : '' }} With</h2>
				<div class="two-columns">
					<label v-if="entryCopy.is_disposed">NICS Number or CCW</label>
					<label v-if="entryCopy.is_disposed">Repair Number</label>
					<div v-if="editing"><input type="text" v-model="entryCopy.nics_number"></div>
					<div v-else class="detail-data">{{ entryCopy.nics_number }}</div>
					<div v-if="editing"><input type="text" v-model="entryCopy.repair_number"></div>
					<div v-else class="detail-data">{{ entryCopy.repair_number }}</div>
				</div>
				<template v-if="entryCopy.disposal_notes">
					<label v-if="entryCopy.is_disposed"><span v-if="entryCopy.disposed_by_note" class="far fa-check-square">&nbsp;</span>Note</label>
					<textarea v-if="editing" v-model="entryCopy.disposal_notes"></textarea>
					<div v-else class="detail-data">{{ entryCopy.disposal_notes }}</div>
				</template>
				<label>{{ entryCopy.disposal_notes ? 'Additional ' : '' }}Note</label>
				<textarea v-model="entryCopy.additional_disposal_notes" :readonly="hideControls" style="height: 5em;"></textarea>
				<button v-if="!editing && !hideControls" :class="['spaced', entryCopy.additional_disposal_notes ? 'action' : 'disabled' ]" @click="saveNote(0)">Save Note{{ entryCopy.is_disposed ? "" : " (Don't Dispose)" }}</button>
				<button v-if="!editing && !hideControls"  :class="[ entryCopy.additional_disposal_notes  && !entryCopy.is_disposed ? 'action' : 'disabled' ]" @click="saveNote(1)">Dispose With Note</button>
			</div>
		</div>

		<div class="section">
			<h2>Serial Number</h2>
			<div class="three-one-columns">
				<div v-if="editing"><input type="text" v-model="entryCopy.serial_number"></div>
				<div v-else class="detail-data">{{ entryCopy.serial_number }}</div>
			</div>

			<h2 style="margin: 3em 0 0.5em 0;">
				UPC / Condition
				<div style="float: right; font-size: 0.8em;">{{ entryCopy.product_id ? 'Product ID: ' + entryCopy.product_id : 'Not Inventory' }}</div>
			</h2>
			<div class="two-columns">
				<div>
					<input type="text" v-model="entryCopy.upc">
				</div>
				<div>
					<label class="radio first">
						<input type="radio" v-model="entryCopy.is_used" value="0">
						<span><i class="fas fa-check-circle"></i>New</span>
					</label>
					<label class="radio last inline">
						<input type="radio" v-model="entryCopy.is_used" value="1">
						<span><i class="fas fa-check-circle"></i>Used</span>
					</label>
					<div :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" style="margin: 0 0 0 2em;" @click="saveUPCCondition()">Save</div>
				</div>
			</div>
			<div class="three-columns" style="margin: 1em 0 0 0;">
				<div class="button spaced neutral inline" @click="showPrintControls = !showPrintControls">{{ showPrintControls ? 'Hide' : 'Show' }} Print Tags</div>
				<div v-if="entryCopy.product_id" :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="showDisconnectInventory = true">Disconnect Inventory</div>
				<div v-else :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="showConnectInventory = true">Connect Inventory</div>
				<div v-if="entryCopy.product_id" :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="goToProduct()">Manage Product</div>
			</div>
			<span class="message"> &nbsp; {{ saveMessage }}</span>
		</div>

		<template v-if="!hideControls">
			<div v-if="editing" class="section">
				<label>Transaction Serial Number</label>
				<input type="text" v-model="entryCopy.form_number" placeholder="Transaction Serial Number">
				<div class="button cancel spaced" @click="editing = false">Cancel</div>
				<button :class="[ changed ? 'action' : 'disabled' ]" @click="showTip('confirm_move_record')">Save Moved Record</button>
			</div>
			<div v-else class="section">
				<div style="width: 60%; margin: 0 0 1.75em 0;">
					<div class="input-with-control input-with-control-with-tip">
						<input type="text" v-model="entry.form_number" placeholder="Transaction Serial Number" @keyup.enter="searchFormNumbers()">
						<div class="button input-go action" @click="searchFormNumbers()"><i class="fas fa-search"></i></div>
						<span class="inline-tip fas fa-info-circle" @click="showToolTip = true"></span>
					</div>
					<div v-if="form_numbers.length > 0 || formNumberSearchMessage" class="search-result bordered" style="margin: 0 1em 0 0;">
						<div class="controls"><button class="button action" @click="form_numbers = []">X</button></div>
						<ul v-if="form_numbers.length > 0" class="search-list" style="margin: 0 3em 0 0;">
							<li class="clickable-list-item" v-for="(form_number, index) in form_numbers" @click="assignFormNumber(form_number)">
								{{ form_number }}
							</li>
						</ul>
						<ul v-else class="search-list no-results">
							<li>{{ formNumberSearchMessage }}</li>
						</ul>
					</div>
				</div>
				<button :class="[ 'spaced', entryCopy.is_disposed ? 'disabled' : 'action' ]" @click="doDispose()">Dispose Record</button>
				<button :class="[ entryCopy.moved_to_ffl_log_book_entry_id ? 'disabled' : 'neutral' ]" @click="doMove()">Move Record</button>&nbsp;
				<span v-if="!entryCopy.moved_to_ffl_log_book_entry_id" class="inline-tip fas fa-info-circle" @click="showTip('move_record')"></span>
			</div>
		</template>

		<div v-if="showPrintControls" style="grid-column: 1 / span 2; margin: 0 0 0 1em; position: relative;">
			<h2>Print tags</h2>
			<tag-print :productDetail="entryCopy" :serialNumbers="[entryCopy.serial_number]"></tag-print>
		</div>

		<div class="modal" v-if="showToolTip">
			<div class="inner">
				<h2>Transaction Serial Number</h2>
				<div class="content">
					<p>You can enter the Transferor's / Seller's Transaction Serial Number from the 4473 associated with this disposal.</p>
					<p>This will help you link this disposal to that specific 4473 in your electronic or paper filing system.</p>
				</div>
				<div class="controls">
					<div class="button cancel" @click="showToolTip = false">Got It</div>
				</div>
			</div>
		</div>

		<div class="modal" v-if="showModal">
			<div class="inner">
				<h2>{{ $caplitalizeWords(modalFor) }}</h2>
				<div class="content">
					<div v-html="modalContent"></div>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="showModal = false">{{ modalShowConfirm ? 'Cancel' : 'Got It' }}</div>
					<div v-if="modalShowConfirm && modalFor == 'Confirm Move Record'" :class="['button', doingModalAction ? 'disabled' : 'action', 'spaced']" @click="saveMove()">Confirm Move Record</div>
					<div v-if="modalShowConfirm && modalFor == 'Confirm Clear Sale Info'" :class="['button', doingModalAction ? 'disabled' : 'action', 'spaced']" @click="clearDispositionInfo()">Clear Sale Info</div>
				</div>
			</div>
		</div>

		<div v-if="showConnectInventory" class="modal medium-modal">
			<div class="inner">
				<h2>Connect To Inventory</h2>
				<div class="content">
					<p>
						This firearm is on hand but not connected to any store inventory.<br>
						Search for a Store Product by UPC or description...
					</p>
					<div class="input-with-control">
						<input type="search" v-model="inventorySearchTerm" placeholder="Scan or enter..." @search="searchInventory()">
						<div :class="['button', inventorySearchTerm ? 'action' : 'disabled', 'input-go']" @click="searchInventory()"><i class="fas fa-search" v-if="!inventorySearching"></i><i class="far fa-compass fa-spin" v-else></i></div>
					</div>
					<div v-if="inventorySearchMessage" class="note">
						{{ inventorySearchMessage }}
						<div v-if="inventoryList.length == 0">
							Search again or <router-link to="/inventory/manage-products/store">manage your Store Products...</router-link>
						</div>
					</div>
					<table v-else-if="inventoryList.length > 0" class="clickable-list">
						<tr>
							<th></th>
							<th>UPC / Description</th>
							<th>Dept / Cat</th>
							<th>Cost / Price</th>
						</tr>
						<tr v-for="(item, index) in inventoryList" class="clickable-list-item" @click="showAssignInventory(item)">
							<td style="padding-right: 2em;"><img :src="item.image_src" style="max-height: 3em; max-width: 3em;" /></td>
							<td style="padding-right: 2em;">{{ item.upc }}<br>{{ item.description }}</td>
							<td style="padding-right: 2em;">{{ item.department }}<br>{{ item.category }}</td>
							<td class="right">{{ item.cost }}<br>{{ item.price }}</td>
						</tr>
					</table>

					<div v-else class="note">
						<b>NOTE:</b> you can only connect to an existing store product.<br>
						<router-link to="/inventory/manage-products/store">Need to create a Store Product?</router-link>
					</div>

					<div v-if="confirmAssignInventory.product_id" style="margin: 1em 0 0 0;">
						<p>
							You have selected <b>{{ confirmAssignInventory.description }}</b> (product id {{ confirmAssignInventory.product_id }})<br>
							to connect as inventory to this log book record. This will create an inventory serial number<br>
							and adjust your available quantity. Do you want to proceed?
						</p>
					</div>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="showConnectInventory = false">Cancel</div>
					<div v-if="confirmAssignInventory.product_id" :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="doAssignInventory()">Yes, Connect Inventory</div>
				</div>
			</div>
		</div>

		<div v-if="showDisconnectInventory" class="modal medium-modal">
			<div class="inner">
				<h2>Disconnect From Inventory</h2>
				<div class="content">
					<p>
						This firearm is connected to store inventory product id <b>{{ entryCopy.product_id }}</b>.<br>
						Disconnecting will remove the inventory serial number and adjust<br>
						your available quantity. Do you want to proceed?</p>
					<p v-if="inventorySearchMessage" class="note">
						{{ inventorySearchMessage }}
					</p>
				</div>
				<div class="controls">
					<div class="button cancel spaced" @click="showDisconnectInventory = false">Cancel</div>
					<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="doDisconnectInventory()">Yes, Disconnect Inventory</div>
				</div>
			</div>
		</div>

	</div>
</div>
</template>

<script>
import StateSelect from '@/components/StateSelect.vue'
import TagPrint from '@/components/TagPrint.vue'
export default {
	name: 'list-detail',
	props: ['entry', 'hideControls'],
	components: {
        'state-select': StateSelect,
		'tag-print': TagPrint
    },
	data() {
		return {
			entryCopy: {},
			showModal: false,
    		modalFor: '',
    		modalContent: '',
    		modalMessage: '',
    		modalShowConfirm: false,
			doingModalAction: false,
    		logbooks: [],
    		gun_types: [],
			fflNumberInfo: {},
    		editing: false,
    		showToolTip: false,
    		formNumberSearchMessage: '',
    		form_numbers: [],
			saveMessage: '',
			saving: false,
			showPrintControls: false,
			showConnectInventory: false,
			inventorySearchTerm: '',
			inventorySearching: false,
			inventorySearchMessage: '',
			inventoryList: [],
			confirmAssignInventory: {},
			showDisconnectInventory: false,
		}
	},
	created() {
		this.apiCall({ destination: 'get_log_book_control_lists' }).then(obj => {
			if (obj.status == 'success') {
				this.logbooks = obj.logbooks
		 		this.gun_types = obj.gun_types
				this.fflNumberInfo = obj.ffl_number_info
			}
		}).catch(err => {
			console.log(err)
		})
		this.entryCopy = this.$copy(this.entry)
	},
    watch: {
		entry(newVal) {
			if (newVal) {
				this.entryCopy = this.$copy(this.entry)
			}
		}
	},
	computed: {
    	changed() {
    		return this.$changed(this.entry, this.entryCopy)
    	}
	},
	methods: {
		cancel() {
			this.$router.go(-1)
		},
		reloadList() {
			this.$emit('reloadList')
		},
		doDispose() {
			if (!this.entryCopy.is_disposed) {
				this.$router.push('/logbooks/dispose/' + this.entryCopy.ffl_log_book_entry_id + (this.entryCopy.disposal_contact_id ? '?disposal_contact_id=' + this.entryCopy.disposal_contact_id : ''))
			}
		},
		doMove() {
			if (!this.entryCopy.moved_to_ffl_log_book_entry_id) {
				this.apiCall({ destination: 'get_log_book_control_lists' }).then(obj => {
					if (obj.status == 'success') {
						this.logbooks = obj.logbooks
				 		this.gun_types = obj.gun_types
						this.fflNumberInfo = obj.ffl_number_info
					}
				}).catch(err => {
					console.log(err)
				})
				this.editing = true
				document.getElementById('record_top').scrollTop = 0
			}
		},
		showTip(which) {
			switch (which) {
				case 'move_record':
		    		this.modalFor = 'Move A Record'
					this.modalContent  = "<p>Moving a record allows you to correct an entry error while remaining compliant with ATF requirements.</p>";
					this.modalContent += "<p>The current record becomes disposed and noted as moved to a new record. The new record can then be edited with correct information.</p>"
					this.modalShowConfirm = false
					break;
				case 'confirm_move_record':
					if (!this.changed) {
						return false
					}
		    		this.modalFor = 'Confirm Move Record'
					this.modalContent  = "<p>You are about to move record <b>" + this.entry.sequence_code + "</b> to a new record.</p>";
					this.modalContent += "<p>The original record " + (this.entry.is_disposed ? "remain disposed but" : "become disposed and") + " will be noted as moved to the new record. The new record will contain the data you have just entered or modified.</p>"
					this.modalContent += "<p>This action cannot be undone.</p>"
					this.modalShowConfirm = true
					break;
				case 'confirm_clear_disposition_info':
		    		this.modalFor = 'Confirm Clear Sale Info'
					this.modalContent  = "<p>You are about to clear sale info for this record. This is most common when cancelling a layaway order originally created in your POS.</p>";
					this.modalContent += "<p>Receipt Info, ATF Details, and Serial Number will not be cleared.</p>"
					this.modalContent += "<p>This action cannot be undone.</p>"
					this.modalShowConfirm = true
					break;
			}
			this.showModal = true
		},
		saveNote(disposeByNote) {
			if (this.saving || !this.entryCopy.additional_disposal_notes) { return }
			this.saving = true
			this.entryCopy.disposed_by_note = disposeByNote
			this.entryCopy.disposal_notes = this.entryCopy.additional_disposal_notes
			this.entryCopy.additional_disposal_notes = ''
			this.apiCall({ destination: 'save_item_ffl_log_book_entry_notes', data: { entry: this.entryCopy } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.entryCopy.disposal_notes = obj.entry.disposal_notes
					this.entryCopy.is_disposed = obj.entry.is_disposed
					if (disposeByNote) {
						this.reloadList()
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		updateSelectedStateOriginator(state) {
			this.entryCopy.originator_state = state
		},
		updateSelectedStateDisposal(state) {
			this.entryCopy.disposal_state = state
		},
		saveMove() {
			if (this.doingModalAction || this.saving) {
				return false
			}
			let requiredFields = ['ffl_log_book_id', 'receipt_date', 'manufacturer', 'gun_type', 'caliber', 'originator_full_name', 'originator_address_1', 'originator_city', 'originator_state', 'originator_zip_code']
			let error = ''
			requiredFields.forEach((field) => {
				if (!this.entryCopy[field]) {
					error = field
					return false
				}
			})
			if (error) {
				this.modalContent += "<p class='modal-result'>Some required info is missing (" + error + ")</p>"
				return false
			}
			this.doingModalAction = true
			this.apiCall({ destination: 'save_item_ffl_log_book_entry_move', data: { entry: this.entryCopy } }).then(obj => {
				this.modalContent += "<p class='modal-result'>" + obj.message + "</p>"
				if (obj.status == 'success') {
					this.editing = false
					this.entryCopy.disposal_notes = obj.disposal_notes
					this.entryCopy.moved_to_ffl_log_book_entry_id = obj.moved_to_ffl_log_book_entry_id
					this.entryCopy.is_disposed = true
					var timer = setTimeout((function() {
						this.showModal = false
						this.doingModalAction = false
						this.reloadList()
					}.bind(this)), 2000)
				} else {
					this.doingModalAction = false
				}
			}).catch(err => {
				console.log(err)
			})
		},
		searchFormNumbers() {
			this.apiCall({ destination: 'get_list_4473_form_numbers', data: { search_term: this.entry.form_number }}).then(obj => {
				if (obj.status == 'error') {
					this.formNumberSearchMessage = obj.message
				} else {
					if (obj.form_numbers.length > 0) {
						this.form_numbers = obj.form_numbers
					} else {
						this.formNumberSearchMessage = 'No Transaction Serial Numbers found'
					}
				}
			})
		},
		assignFormNumber(formNumber) {
			this.entry.form_number = formNumber
			this.form_numbers = []
		},
		clearDispositionInfo() {
			if (this.entry.is_diposed || !this.entry.disposal_full_name || this.doingModalAction) {
				return false
			}
			this.doingModalAction = true
			this.apiCall({ destination: 'clear_ffl_log_book_entry_disposition_info', data: { ffl_log_book_entry_id: this.entry.ffl_log_book_entry_id }}).then(obj => {
				this.modalContent += "<p class='modal-result'>" + obj.message + "</p>"
				if (obj.status == 'success') {
					// clear full_name to hide all disposition info
					this.entryCopy.disposal_full_name = ''
					// clear rest of data in case user decides to move before returning to list
					this.entryCopy.disposal_contact = ''
					this.entryCopy.disposal_date = ''
					this.entryCopy.disposal_address_1 = ''
					this.entryCopy.disposal_address_2 = ''
					this.entryCopy.disposal_citty = ''
					this.entryCopy.disposal_state = ''
					this.entryCopy.disposal_ffl_number = ''
					var timer = setTimeout((function() {
						this.showModal = false
						this.doingModalAction = false
						this.reloadList()
					}.bind(this)),2000)
				} else {
					this.doingModalAction = false
				}
			})
		},
		saveUPCCondition() {
			if (this.saving) { return }
			this.saving = true
			this.saveMessage = ''
			this.apiCall({ destination: 'save_item_ffl_log_book_entry_upc_condition', data: { ffl_log_book_entry_id: this.entry.ffl_log_book_entry_id, upc: this.entryCopy.upc, is_used: this.entryCopy.is_used }}).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.saveMessage = 'UPC / Condition saved!'
				} else {
					this.saveMessage = obj.message
				}
			})
		},
        searchInventory() {
            if (this.inventorySearching || !this.inventorySearchTerm) { return }
            this.inventoryList = []
			this.inventorySearchMessage = ''
            this.inventorySearching = true
			this.confirmAssignInventory = {}
			this.apiCall({ destination: 'get_list_products', data: { search_term: this.inventorySearchTerm, ignore_availability: true } }).then(obj => {
                this.inventorySearching = false
				if (obj.status == 'success') {
                    if (obj.list.length > 0) {
    					this.inventoryList = obj.list
                    } else {
                        this.inventorySearchMessage = 'No matching item found in your store products.'
                    }
				} else {
					this.inventorySearchMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
        },
		showAssignInventory(item) {
			this.confirmAssignInventory = item
		},
        doAssignInventory() {
			if (this.saving) { return }
			let productId = this.confirmAssignInventory.product_id
			this.inventorySearchTerm = ''
			this.confirmAssignInventory = {}
			this.inventorySearchMessage = 'Connecting inventory...'
			this.saving = true
			this.apiCall({ destination: 'save_item_logbook_assign_inventory', data: { ffl_log_book_entry_id: this.entryCopy.ffl_log_book_entry_id, product_id: productId } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.entryCopy.product_id = obj.product_id
					this.entryCopy.upc = obj.upc
					this.inventorySearchMessage = 'Inventory connected!'
					this.messageTimeout = setTimeout(() => { 
						this.showConnectInventory = false
						this.inventoryList = []
						this.inventorySearchMessage = ''
					}, 1500)
				} else {
					this.inventorySearchMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doDisconnectInventory() {
			if (this.saving) { return }
			this.inventorySearchMessage = 'Disconnecting inventory...'
			this.saving = true
			this.apiCall({ destination: 'save_item_logbook_disconnect_inventory', data: { ffl_log_book_entry_id: this.entryCopy.ffl_log_book_entry_id, product_id: this.entryCopy.product_id } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.entryCopy.product_id = ''
					this.entryCopy.upc = ''
					this.inventorySearchMessage = 'Inventory disconnected!'
					this.messageTimeout = setTimeout(() => { 
						this.showDisconnectInventory = false
						this.inventorySearchMessage = ''
					}, 1500)
				} else {
					this.inventorySearchMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToProduct() {
			this.$router.push('/inventory/manage-products/detail/' + this.entryCopy.product_id)
		}
	}
}
</script>
